var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-first-component"},[_c('h1',[_vm._v("🎉 哪里不喜欢就改哪里 ")]),_c('p',[_vm._v("比如，改改主题色")]),_c('div',{staticClass:"demo"},[_c('p',[_vm._v("计数器: "+_vm._s(_vm.count))]),_c('button',{on:{"click":_vm.increment}},[_vm._v("点击 +1")]),_c('button',{on:{"click":_vm.reset}},[_vm._v("重置")])]),_c('p',[_vm._v("当前时间: "+_vm._s(_vm.currentTime))])])
}
var staticRenderFns = []

export { render, staticRenderFns }